// Tour registry. To add a tour: define it (see defineTour.js), tag its targets
// with data-tour="…", add its copy to src/i18n/{en,ar}/tour.json, list it here.
import welcomeTour from './welcome';
import moduleTours from './modules';

export const WELCOME_TOUR_ID = welcomeTour.id;

const tours = [welcomeTour, ...moduleTours];

export default tours;
